import React from 'react';
import { Box, Grid, Typography, Container, Stack, useTheme,styled,Button } from '@mui/material';
import web from '../images/webDev.jpg';
import react from '../images/react.png';
import node from '../images/nodeLogo.png';
import mongoDB from '../images/MongoDB.png';
import webTeam from '../images/webTeam.jpg';
import webTik from '../images/tik.png';
import techTeam from '../images/digitalisation.png';
import cloud from '../images/server.png';
import practice from '../images/practice.png';
import testing from '../images/search.png';
import team from '../images/team-management.png';
import back1 from '../images/tm.jpg';

const StyledButton = styled(Button)(({ theme }) => ({
    marginTop: theme.spacing(3),
    padding: theme.spacing(1.5, 4),
    borderRadius: '50px',
    backgroundColor: '#fff',
    color: '#000',
    fontWeight: 'bold',
    textTransform: 'none',
    boxShadow: theme.shadows[3],
    transition: 'background-color 0.3s, transform 0.3s, color 0.3s', // Added 'color 0.3s'
    '&:hover': {
        backgroundColor: '#a974d0', // Changed hover background color
        color: '#fff', // Added hover text color
        transform: 'translateY(-2px)',
    },
}));


// Reusable component for technology sections
const TechnologyCard = ({ icon, title, description }) => {
    const theme = useTheme();
    return (
        <Stack
            direction="column"
            alignItems="center"
            spacing={2}
            sx={{
                p: 3,
                borderRadius: '12px',
                transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                '&:hover': {
                    transform: 'translateY(-10px)',
                    boxShadow: theme.shadows[6],
                },
            }}
        >
            <Box component="img" src={icon} alt={title} sx={{ height: '80px', width: 'auto' }} />
            <Typography variant="h5" sx={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 'bold', color: theme.palette.text.primary }}>
                {title}
            </Typography>
            <Typography variant="body1" sx={{ fontFamily: 'Montserrat, sans-serif', color: theme.palette.text.secondary, textAlign: 'center' }}>
                {description}
            </Typography>
        </Stack>
    );
};

// Reusable component for features sections
const FeatureCard = ({ icon, title, description }) => {
    const theme = useTheme();
    return (
        <Stack direction={{ xs: 'row', md: 'row' }} alignItems="center" spacing={3}>
            <Box component="img" src={icon} alt={title} sx={{ height: '40px', width: 'auto' }} />
            <Box>
                <Typography variant="h6" sx={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 'bold', color: theme.palette.text.primary, mb: 1 }}>
                    {title}
                </Typography>
                <Typography variant="body2" sx={{ fontFamily: 'Montserrat, sans-serif', color: theme.palette.text.secondary, textAlign: 'justify' }}>
                    {description}
                </Typography>
            </Box>
        </Stack>
    );
};

// Reusable component for benefits sections
const BenefitCard = ({ icon, title, description }) => {
    const theme = useTheme();
    return (
        <Box sx={{
            p: 3,
            borderRadius: '12px',
            backgroundColor: theme.palette.background.paper,
            boxShadow: theme.shadows[2],
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center',
            height: '100%',
            transition: 'transform 0.3s ease, box-shadow 0.3s ease',
            '&:hover': {
                transform: 'translateY(-10px)',
                boxShadow: theme.shadows[8],
            },
        }}>
            <Box component="img" src={icon} alt={title} sx={{ height: '80px', width: 'auto', mb: 2 }} />
            <Typography variant="h6" sx={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 'bold', color: theme.palette.text.primary, mb: 1 }}>
                {title}
            </Typography>
            <Typography variant="body2" sx={{ fontFamily: 'Montserrat, sans-serif', color: theme.palette.text.secondary }}>
                {description}
            </Typography>
        </Box>
    );
};

function WebDev() {
    const theme = useTheme();

    return (
        <>
            {/* Hero Section */}
            <Box
                sx={{
                    height: { md: '60vh', xs: '40vh' },
                    backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url(${web})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    color: 'white',
                    textAlign: 'center',
                    p: 2,
                }}
                className='no-select'
            >
                <Typography
                    variant="h2"
                    component="h1"
                    sx={{
                        fontFamily: "Montserrat, sans-serif",
                        fontWeight: '600',
                        fontSize: { xs: '3rem', md: '6rem' },
                        mb: 2,
                    }}
                >
                    Web Development
                </Typography>
                <Typography
                    variant="body1"
                    sx={{
                        fontFamily: "Montserrat, sans-serif",
                        fontWeight: '500',
                        fontSize: { xs: '0.875rem', md: '1.2rem' },
                    }}
                >
                    <a href='/' style={{ textDecoration: 'none', color: 'white' }}>Home</a> / <span style={{ color: theme.palette.secondary.main }}>Web Development</span>
                </Typography>
            </Box>

            {/* Introduction and Technology Stack */}
            <Container maxWidth="lg" sx={{ my: { xs: 8, md: 12 } }}>
                <Box mb={6} textAlign="center">
                    <Typography variant="h6" sx={{ color: '#a974d0', fontFamily: 'Montserrat, sans-serif', fontWeight: '600', mb: 1 }}>
                        OUR APPROACH
                    </Typography>
                    <Typography variant="h3" component="h2" sx={{ fontFamily: 'Montserrat, sans-serif', fontWeight: '500', mb: 3, color: theme.palette.text.primary }}>
                        Web Development
                    </Typography>
                    <Typography variant="body1" sx={{ fontFamily: 'Montserrat, sans-serif', color: theme.palette.text.secondary, maxWidth: '800px', mx: 'auto' }}>
                        The modern-day world is primarily an online world; no matter the service or business you conduct, having an online website would drastically help you move forward. We develop and create websites with various options, including all services and details in a website, working smoothly to the consumer’s benefit. If you are looking for a website that will attract a crowd into your business, you have reached the right place.
                    </Typography>
                </Box>
                <Grid container spacing={5}>
                    <Grid item xs={12} md={4}>
                        <TechnologyCard
                            icon={react}
                            title="React JS"
                            description="React JS is crucial for web development due to its component-based architecture, enabling reusable and maintainable UI components. The virtual DOM enhances performance by optimizing updates. Its declarative syntax simplifies UI state management, making code more predictable and debuggable. A robust ecosystem with extensive libraries and tools further accelerates development."
                        />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <TechnologyCard
                            icon={node}
                            title="Node JS"
                            description="Node.js is vital for web development, enabling server-side scripting with JavaScript, thus unifying client and server-side coding. Its non-blocking, event-driven architecture ensures high performance and scalability. With a robust npm ecosystem, it simplifies development tasks. Node.js excels in handling real-time data, making it ideal for chat services and live updates in modern web applications."
                        />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <TechnologyCard
                            icon={mongoDB}
                            title="MongoDB"
                            description="MongoDB is vital for web development due to its flexible schema, which allows for rapid iteration and handling of unstructured data. Its scalability and performance make it suitable for large-scale applications. As a NoSQL database, MongoDB supports JSON-like documents, simplifying data integration with JavaScript-based technologies like Node.js, making it an ideal choice for modern, dynamic web applications."
                        />
                    </Grid>
                </Grid>
            </Container>

            {/* Why Work With Us Section */}
            <Container maxWidth="lg" sx={{ my: { xs: 8, md: 12 } }}>
                <Grid container spacing={5} alignItems="center">
                    <Grid item xs={12} md={5}>
                        <Box
                            component="img"
                            src={webTeam}
                            alt='web team'
                            sx={{
                                width: '100%',
                                height: 'auto',
                                borderRadius: '12px',
                                boxShadow: theme.shadows[8],
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} md={7}>
                        <Box p={2}>
                            <Typography variant="h4" component="h2" sx={{ color: theme.palette.text.primary, fontWeight: 'bold', mb: 3 }}>
                                Find The Best Team For Your Next Project
                            </Typography>
                            <Typography variant="body1" sx={{ fontFamily: "Montserrat, sans-serif", color: theme.palette.text.secondary, mb: 4, textAlign: 'justify' }}>
                                At our web development team, we take a distinctive approach, setting us apart from the regular firms. We believe in forming a strong partnership with our clients, providing the best tech solutions to transform your business. Our future-oriented mindset ensures that the websites we create are not only effective today but also ready to meet tomorrow's challenges. With our highly skilled team, we adopt a business-centric perspective, crafting websites that are tailored to your specific needs. Our comprehensive development process covers everything from front-end to back-end, resulting in excellent, functional, and user-friendly websites that enhance your business's online presence.
                            </Typography>
                            <Stack spacing={3}>
                                <FeatureCard
                                    icon={webTik}
                                    title="Reliability"
                                    description="We utilize both custom and standard software development processes to efficiently deliver IT projects within defined parameters."
                                />
                                <FeatureCard
                                    icon={webTik}
                                    title="Delivery Mindset"
                                    description="We focus on business-oriented goals and are committed to delivering top-quality products and services using cutting-edge technology for our customers."
                                />
                                <FeatureCard
                                    icon={webTik}
                                    title="Project Management"
                                    description="We place our projects in the capable hands of experienced and qualified software project managers to ensure exceptional outcomes."
                                />
                                <FeatureCard
                                    icon={webTik}
                                    title="Effective Communication"
                                    description="We maintain close communication with our clients, keeping them updated and following all their instructions."
                                />
                            </Stack>
                        </Box>
                    </Grid>
                </Grid>
            </Container>

            {/* Why You Should Work With Us (Grid of Icons) */}
            <Container maxWidth="lg" sx={{ my: { xs: 8, md: 12 } }}>
                <Box textAlign="center" mb={6}>
                    <Typography variant="h4" component="h2" sx={{ color: theme.palette.text.primary, fontWeight: 'bold', mb: 2 }}>
                        Why You Should Work With Us
                    </Typography>
                    <Typography variant="body1" sx={{ fontFamily: 'Montserrat, sans-serif', color: theme.palette.text.secondary, maxWidth: '800px', mx: 'auto' }}>
                        At our web development team, we take a distinctive approach, setting us apart from the regular firms. We believe in forming a strong partnership with our clients, providing the best tech solutions to transform your business. Our future-oriented mindset ensures that the websites we create are not only effective today but also ready to meet tomorrow's challenges. With our highly skilled team, we adopt a business-centric perspective, crafting websites that are tailored to your specific needs. Our comprehensive development process covers everything from front-end to back-end, resulting in excellent, functional, and user-friendly websites that enhance your business's online presence.
                    </Typography>
                </Box>
                <Grid container spacing={4}>
                    <Grid item xs={12} sm={6} md={4}>
                        <BenefitCard
                            icon={techTeam}
                            title="Skilled, hierarchical organization"
                            description="producing and overseeing every project constantly through professional technicians."
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <BenefitCard
                            icon={cloud}
                            title="Cloud and Serverless Experience"
                            description="Delivering high-performance software of exceptional quality at an affordable price."
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <BenefitCard
                            icon={practice}
                            title="Newest Trends In Practice"
                            description="Latest methods and practices being implemented in current industry trends."
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <BenefitCard
                            icon={testing}
                            title="Battle-Tested Process"
                            description="Equipping you with the right tools to thrive in today's market."
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <BenefitCard
                            icon={team}
                            title="Team scaling assistance"
                            description="Scale your team swiftly as needed."
                        />
                    </Grid>
                </Grid>
            </Container>

            <Box
                sx={{
                    height: '35vh',
                    backgroundImage: `url(${back1})`,
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center',
                    color: '#fff',
                }}
            >
                <Box sx={{ p: 2 }}>
                    <Typography
                        variant="h1"
                        sx={{
                            fontFamily: 'Montserrat, sans-serif',
                            fontWeight: '500',
                            fontSize: { md: '6rem', xs: '4rem' },
                        }}
                    >
                        Let's Start
                    </Typography>
                    <Typography
                                                    variant="h6"
                                                    sx={{
                                                        fontFamily: 'Montserrat, sans-serif',
                                                        fontWeight: '700',
                                                        fontSize: { md: '1.25rem', xs: '1rem' },
                                                        mt: 2
                                                    }}
                                                    >
                                                    Empowering businesses through custom software solutions.{' '}
                                                    <span style={{ color: '#a974d0' }}>Your success, our code.</span>
                                                </Typography>
                    <StyledButton href="/contactus">Get In Touch</StyledButton>
                </Box>
            </Box>
        </>
    );
}

export default WebDev;